if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
  liveRegion: this.querySelector('[id^="GalleryStatus"]'),
  viewer: this.querySelector('[id^="GalleryViewer"]'),
  thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
  counterCurrent: this.querySelector('.slider-counter--current'),
  counterTotal: this.querySelector('.slider-counter--total'),
  sliderButtons: this.querySelector('.slider-buttons'),
};
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
        this.bindVariantColorChange();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }
      bindVariantColorChange() {
  const variantInputs = document.querySelectorAll(
    'input[type="radio"][name*="option"], select[name*="option"]'
  );

  variantInputs.forEach((input) => {
    input.addEventListener('change', () => {
      let selectedColor = '';

      if (input.tagName === 'SELECT') {
        selectedColor = input.value;
      } else {
        const checkedInput = document.querySelector(`input[name="${input.name}"]:checked`);
        selectedColor = checkedInput ? checkedInput.value : input.value;
      }

      window.setTimeout(() => {
        this.filterMediaByColor(selectedColor);
      }, 50);
    });
  });
}с

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);
        const selectedColor = document.querySelector('input[name*="Color"]:checked')?.value;
this.filterMediaByColor(selectedColor);

window.setTimeout(() => {
  this.updateVariantSliderCounter(activeMedia);
}, 0);

if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }
      filterMediaByColor(color) {
  if (!this.elements.viewer) return;

  const normalizedColor = (color || '').trim().toLowerCase();
  const mediaItems = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]'));
  const thumbnailItems = this.elements.thumbnails
    ? Array.from(this.elements.thumbnails.querySelectorAll('[data-target]'))
    : [];

  let firstVisibleMedia = null;
  let visibleCount = 0;

  mediaItems.forEach((item) => {
    const alt = (item.dataset.mediaAlt || '').toLowerCase();
    const isMatch = normalizedColor && alt.includes(normalizedColor);

    item.hidden = !isMatch;
    item.classList.remove('is-active');

    if (isMatch) {
      visibleCount += 1;
      if (!firstVisibleMedia) firstVisibleMedia = item;
    }
  });

  thumbnailItems.forEach((item) => {
    const alt = (item.dataset.mediaAlt || '').toLowerCase();
    const isMatch = normalizedColor && alt.includes(normalizedColor);
    item.hidden = !isMatch;
  });

  if (!firstVisibleMedia) {
    const fallbackMedia = mediaItems.find((item) => !item.hidden);
    if (fallbackMedia) firstVisibleMedia = fallbackMedia;
  }

  if (firstVisibleMedia) {
    firstVisibleMedia.classList.add('is-active');

    if (this.elements.viewer.slider) {
      this.elements.viewer.resetPages();
    }

    const activeMediaId = firstVisibleMedia.dataset.mediaId;
    const activeThumbnail = this.elements.thumbnails
      ? this.elements.thumbnails.querySelector(`[data-target="${activeMediaId}"]:not([hidden])`)
      : null;

    if (activeThumbnail) {
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(firstVisibleMedia, activeThumbnail.dataset.mediaPosition);
    }

    this.playActiveMedia(firstVisibleMedia);
    this.updateVariantSliderCounter(firstVisibleMedia);
  } else {
    this.updateVariantSliderCounter(null);
  }
}
      updateVariantSliderCounter(activeMedia) {
  if (!this.elements.counterCurrent || !this.elements.counterTotal || !this.elements.viewer) return;

  const mediaItems = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]')).filter(
    (item) => !item.hidden
  );

  const total = mediaItems.length || 1;
  const activeIndex = activeMedia ? mediaItems.findIndex((item) => item === activeMedia) : 0;

  this.elements.counterCurrent.textContent = activeIndex >= 0 ? activeIndex + 1 : 1;
  this.elements.counterTotal.textContent = total;

  if (this.elements.sliderButtons) {
    if (total <= 1) {
      this.elements.sliderButtons.classList.add('small-hide');
    } else {
      this.elements.sliderButtons.classList.remove('small-hide');
    }
  }
}

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
